module.exports = __webpack_public_path__ + "static/media/default-user.5a021ab9.png";